import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import { NotFoundPageProps } from "../lib/type";

export const NotFoundPage: FC<NotFoundPageProps> = ({ title, description, image, redirect }) => {
    return (
        <section className={"flex h-screen flex-col justify-center"}>
            <Stack className={"flex flex-col items-center gap-2"}>
                {image && (
                    <Box>
                        <Image quality={100} priority {...image} />
                    </Box>
                )}
                <Typography component={"h1"} variant={"h2"}>
                    {title}
                </Typography>
                <Typography
                    component={"p"}
                    variant={"body1"}
                    className={"inline max-w-[600px] text-center"}
                >
                    {description}{" "}
                    {redirect && (
                        <Link href={redirect.href} prefetch={false} className={"inline text-blue underline"}>
                            {redirect.text}
                        </Link>
                    )}
                    {"."}
                </Typography>
            </Stack>
        </section>
    );
};
